import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  zoneOrder: {
    position: 'relative',
    top: '25px',
    right: 0,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: '#2C2D3E',
  },
  zoneImageWithDeleteButton: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  zoneImg: {
    position: 'relative',
    border: 'solid 2px #2C2D3E4D',
    margin: '10px 10px 10px 15px',
    color: 'red',
  },
  zoneImgActive: {
    border: 'solid 2px #3C419A',
  },
  removeButton: {
    position: 'relative',
    verticalAlign: 'top',
    top: '13px',
    left: '-43px',
    zIndex: 100,
  },
  draggingZone: {
    opacity: 0.9,
  },
  activeDropArea: {
    width: '100%',
    borderBottom: 'solid 3px #3C419A',
  },
}));
